/* ============================================
   GOOD FORM STUDIOS — Theme JavaScript
   v6.0 — Final UX pass: scroll-reveal, smooth
   interactions, announcement dismiss
   ============================================ */

(function() {
  'use strict';

  /* ------------------------------------------
     Mobile Menu Toggle
     ------------------------------------------ */
  function initMobileMenu() {
    var toggle = document.querySelector('.site-header__menu-toggle');
    var nav = document.querySelector('.site-header__nav');

    if (!toggle || !nav) return;

    toggle.addEventListener('click', function() {
      nav.classList.toggle('is-open');
      var isOpen = nav.classList.contains('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
    });

    // Close on click outside
    document.addEventListener('click', function(e) {
      if (!toggle.contains(e.target) && !nav.contains(e.target)) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  /* ------------------------------------------
     Sticky header with scroll state
     ------------------------------------------ */
  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var scrolled = false;
    function checkScroll() {
      var shouldBeScrolled = window.scrollY > 10;
      if (shouldBeScrolled !== scrolled) {
        scrolled = shouldBeScrolled;
        header.classList.toggle('is-scrolled', scrolled);
      }
    }
    window.addEventListener('scroll', checkScroll, { passive: true });
    checkScroll();
  }

  /* ------------------------------------------
     Announcement Bar Dismiss
     ------------------------------------------ */
  function initAnnouncementDismiss() {
    var bar = document.querySelector('.announcement-bar');
    var btn = bar ? bar.querySelector('.announcement-bar__dismiss') : null;
    if (!bar || !btn) return;

    btn.addEventListener('click', function() {
      bar.classList.add('is-dismissed');
      // Store dismissal for this session
      try { sessionStorage.setItem('announcement-dismissed', '1'); } catch(e) {}
    });

    // Restore dismissed state
    try {
      if (sessionStorage.getItem('announcement-dismissed') === '1') {
        bar.classList.add('is-dismissed');
      }
    } catch(e) {}
  }

  /* ------------------------------------------
     Scroll-Reveal (IntersectionObserver)
     ------------------------------------------ */
  function initScrollReveal() {
    var targets = document.querySelectorAll('.reveal, .reveal-stagger');
    if (!targets.length) return;

    // Skip if user prefers reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    targets.forEach(function(el) { observer.observe(el); });
  }

  /* ------------------------------------------
     Collapsible Sections
     ------------------------------------------ */
  function initCollapsibles() {
    var triggers = document.querySelectorAll('.collapsible__trigger');

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var content = this.nextElementSibling;
        var isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', !isExpanded);
        content.classList.toggle('is-open');
      });
    });
  }

  /* ------------------------------------------
     Variant Selector
     ------------------------------------------ */
  function initVariantSelector() {
    var options = document.querySelectorAll('.variant-selector__option');

    options.forEach(function(option) {
      option.addEventListener('click', function() {
        if (this.classList.contains('is-unavailable')) return;

        // Deselect siblings
        var siblings = this.parentElement.querySelectorAll('.variant-selector__option');
        siblings.forEach(function(s) { s.classList.remove('is-selected'); });

        this.classList.add('is-selected');

        // Update hidden variant input if present
        var variantId = this.dataset.variantId;
        var form = this.closest('form');
        if (form && variantId) {
          var input = form.querySelector('input[name="id"]');
          if (input) input.value = variantId;

          // Update price display
          var priceEl = document.querySelector('.product-page__price');
          if (priceEl && this.dataset.price) {
            priceEl.textContent = this.dataset.price;
          }
        }
      });
    });
  }

  /* ------------------------------------------
     Quantity Selector
     ------------------------------------------ */
  function initQuantitySelector() {
    document.querySelectorAll('.quantity-selector').forEach(function(selector) {
      var input = selector.querySelector('.quantity-selector__input');
      var minusBtn = selector.querySelector('[data-action="decrease"]');
      var plusBtn = selector.querySelector('[data-action="increase"]');

      if (!input) return;

      if (minusBtn) {
        minusBtn.addEventListener('click', function() {
          var current = parseInt(input.value) || 1;
          if (current > 1) input.value = current - 1;
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function() {
          var current = parseInt(input.value) || 1;
          input.value = current + 1;
        });
      }
    });
  }

  /* ------------------------------------------
     Product Image Gallery
     ------------------------------------------ */
  function initProductGallery() {
    var thumbs = document.querySelectorAll('.product-page__thumb');
    var mainImage = document.querySelector('.product-page__main-image');

    if (!mainImage || !thumbs.length) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        mainImage.src = this.dataset.fullSrc || this.src;
        mainImage.alt = this.alt;

        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
      });
    });
  }

  /* ------------------------------------------
     UX FIX [Interactions]: AJAX Cart with loading 
     state and success confirmation
     ------------------------------------------ */
  function initAjaxCart() {
    var forms = document.querySelectorAll('form[action="/cart/add"]');

    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        var btn = form.querySelector('.btn[type="submit"]');
        var originalText = btn ? btn.textContent.trim() : '';
        var formData = new FormData(form);

        // Loading state
        if (btn) {
          btn.classList.add('is-loading');
          btn.textContent = '';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(response) { return response.json(); })
        .then(function(data) {
          // Update cart count
          updateCartCount();

          // Success state
          if (btn) {
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            btn.textContent = 'Added ✓';

            setTimeout(function() {
              btn.classList.remove('is-added');
              btn.textContent = originalText;
            }, 2000);
          }
        })
        .catch(function(error) {
          console.error('Error adding to cart:', error);
          if (btn) {
            btn.classList.remove('is-loading');
            btn.textContent = originalText;
          }
        });
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var countEl = document.querySelector('.site-header__cart-count');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      });
  }

  /* ------------------------------------------
     UX FIX [Product Page]: Sticky ATC bar on mobile
     Shows when the main ATC button scrolls out of view
     ------------------------------------------ */
  function initStickyATC() {
    var stickyBar = document.querySelector('.sticky-atc');
    var mainBtn = document.querySelector('.product-page .btn[type="submit"]');

    if (!stickyBar || !mainBtn) return;

    var isVisible = false;

    function checkVisibility() {
      var rect = mainBtn.getBoundingClientRect();
      var shouldShow = rect.bottom < 0;

      if (shouldShow !== isVisible) {
        isVisible = shouldShow;
        stickyBar.classList.toggle('is-visible', isVisible);
      }
    }

    window.addEventListener('scroll', checkVisibility, { passive: true });
    checkVisibility();

    // Wire up sticky ATC button
    var stickyBtn = stickyBar.querySelector('.btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        mainBtn.click();
      });
    }
  }

  /* ------------------------------------------
     Initialize Everything
     ------------------------------------------ */
  function init() {
    initMobileMenu();
    initStickyHeader();
    initAnnouncementDismiss();
    initScrollReveal();
    initCollapsibles();
    initVariantSelector();
    initQuantitySelector();
    initProductGallery();
    initAjaxCart();
    initStickyATC();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
